import { Pipe, PipeTransform } from '@angular/core';
import { ApiSmsHelperService } from './sms-helper.service';
import { ucFirst } from '../helpers/function/uc-first';

@Pipe({
  name: 'apiSms',
})
export class ApiSmsHelperPipe implements PipeTransform {
  constructor(private _apiSmsHelperSrv: ApiSmsHelperService) {}

  transform(railGuard: any, ...args: any[]): any {
    const [fct] = args;
    args.shift();
    return (this._apiSmsHelperSrv as any)['get' + ucFirst(fct)](
      railGuard,
      ...args
    );
  }
}

@Pipe({
  name: 'apiSmsU',
  pure: false,
})
export class ApiSmsHelperUnpurePipe
  extends ApiSmsHelperPipe
  implements PipeTransform {}
